import supabase from '../supabaseClient'

/**
 * Updates the last_active timestamp for a teacher
 * @param {string} teacherId - The teacher's UUID
 * @returns {Promise<{error: any}>} - Returns error if any, null if successful
 */
export const updateTeacherLastActive = async (teacherId) => {
  if (!teacherId) {
    console.warn('Teacher ID is required to update last active timestamp')
    return { error: 'Teacher ID is required' }
  }

  try {
    const { error } = await supabase
      .from('teachers')
      .update({ 
        last_active: new Date().toISOString() 
      })
      .eq('id', teacherId)

    if (error) {
      console.error('Error updating teacher last_active:', error)
      return { error }
    }

    return { error: null }
  } catch (error) {
    console.error('Error updating teacher last_active:', error)
    return { error }
  }
}

/**
 * Updates the last_active timestamp for a teacher based on the current user's ID
 * Only updates if the current user is a teacher
 * @param {object} user - The current authenticated user
 * @param {string} userRole - The current user's role
 * @returns {Promise<{error: any}>} - Returns error if any, null if successful
 */
export const updateCurrentTeacherActivity = async (user, userRole) => {
  if (!user || userRole !== 'teacher') {
    return { error: null } // Not an error, just not a teacher
  }

  return await updateTeacherLastActive(user.id)
}
